import * as React from 'react'
import * as Yup from 'yup'
import { Formik, Form } from 'formik'
import { styled } from '@mui/material/styles'
import { Grid, Box, InputAdornment, Button, Alert } from '@mui/material'
import { AccountCircle } from '@mui/icons-material'
import { schema } from '../../utils/schemaValidation'
import Textfield from '../FormsUI/Textfield'

const BUTTON_COLOR = 'var(--color-green-light)'
const TEXT_BUTTON_COLOR = '#EDEEFF'

const ButtonCustom = styled(Button)({
  height: '2em',
  backgroundColor: BUTTON_COLOR,
  textTransform: 'capitalize',
  fontFamily: 'Avenir Next',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '22px',
  color: TEXT_BUTTON_COLOR,
  fontSize: '16px',
  '&:hover': {
    backgroundColor: '#0fa73d',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: BUTTON_COLOR,
    borderColor: BUTTON_COLOR,
  },
})

const boxStyle = {
  width: 405,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: '25px',
  textAlign: 'center',
  borderRadius: '14px',
}

const EmailInputForm = ({ onSubmit, error }) => {
  const INITIAL_FORM_STATE = { email: '' }
  const FORM_VALIDATION = Yup.object().shape({ ...schema.EMAIL })

  return (
    <Box sx={boxStyle}>
      <Formik
        initialValues={{ ...INITIAL_FORM_STATE }}
        validationSchema={FORM_VALIDATION}
        onSubmit={async email => await onSubmit(email)}>
        <Form>
          <Grid container spacing={2} sx={{ pt: 0, width: '100%', ml: 0 }}>
            <Grid item xs={12} style={{ paddingLeft: 0 }}>
              <Textfield
                name="email"
                label="Correo electrónico"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle />
                    </InputAdornment>
                  ),
                }}
                placeholder="user@example.com"
              />
            </Grid>
            {error && (
              <Grid item xs={12} style={{ paddingLeft: 0 }}>
                <Alert severity="error">
                  El usuario (correo electrónico) no se encuentra registrado.
                </Alert>
              </Grid>
            )}
            <Grid item xs={12} style={{ paddingLeft: 0 }}>
              <ButtonCustom variant="contained" fullWidth type="submit">
                Restuarar password
              </ButtonCustom>
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </Box>
  )
}

export default EmailInputForm
